import React from 'react';
import PropTypes from 'prop-types';

import Tag from 'components/tags/tag';

export default function SearchPageCheckboxGroupTag({
  filter,
  label,
  name,
  newDesignSystem = false,
  options,
  onRemove,
}) {
  return (
    <React.Fragment>
      {filter.map(selected => (
        <Tag
          key={selected}
          newDesignSystem={newDesignSystem}
          removable
          onRemove={() => onRemove({ target: { value: selected } })}
        >
          {label}: {options.find(o => selected === o.value).label}
        </Tag>
      ))}
    </React.Fragment>
  );
}

SearchPageCheckboxGroupTag.propTypes = {
  filter: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  newDesignSystem: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      value: PropTypes.any,
      label: PropTypes.any,
    })
  ).isRequired,
  onRemove: PropTypes.func.isRequired,
};
